/** Merge non-empty prefill values into a draft (strings, arrays, primitives). */
export function mergePartialDraft<T extends object>(base: T, prefill: Partial<T>): T {
  const next = { ...base };
  (Object.keys(prefill) as (keyof T)[]).forEach((key) => {
    const value = prefill[key];
    if (value === undefined || value === null) return;
    if (typeof value === 'string' && !value.trim()) return;
    if (Array.isArray(value) && value.length === 0) return;
    (next as Record<string, unknown>)[key as string] = value;
  });
  return next;
}

/** Whether the flow state was prefilled from parsed user input (vs operator demo defaults). */
export function hasParsedInputPrefill(aiFilledFields?: string[]): boolean {
  return (aiFilledFields?.length ?? 0) > 0;
}

/** Field keys that have a meaningful value in a partial prefill. */
export function aiFilledKeysFromPartial<T extends object>(prefill: Partial<T>): string[] {
  const keys: string[] = [];
  (Object.keys(prefill) as (keyof T)[]).forEach((key) => {
    const value = prefill[key];
    if (value === undefined || value === null) return;
    if (typeof value === 'string' && value.trim()) keys.push(String(key));
    else if (Array.isArray(value) && value.length > 0) keys.push(String(key));
    else if (typeof value === 'number' || typeof value === 'boolean') keys.push(String(key));
  });
  return keys;
}
